import { render, staticRenderFns } from "./FinalStep.vue?vue&type=template&id=5020bc90&scoped=true&"
import script from "./FinalStep.vue?vue&type=script&lang=js&"
export * from "./FinalStep.vue?vue&type=script&lang=js&"
import style0 from "./FinalStep.vue?vue&type=style&index=0&id=5020bc90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020bc90",
  null
  
)

export default component.exports